import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";
import es from "./locales/es.json";
import en from "./locales/en.json";

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources: { es: { translation: es }, en: { translation: en } },
    fallbackLng: "es",
    supportedLngs: ["es", "en"],
    interpolation: { escapeValue: false },
    detection: {
      order: ["localStorage", "navigator"],
      caches: ["localStorage"],
      lookupLocalStorage: "tah_lang",
    },
  });

// `<html lang>` sigue el idioma activo (WCAG 3.1.1, CONCEPTO_MARCA.md §9): se fija
// con el idioma ya resuelto por LanguageDetector desde el primer render, y se
// vuelve a fijar en cada cambio de idioma posterior.
document.documentElement.lang = i18n.resolvedLanguage || i18n.language;
i18n.on("languageChanged", (lng) => {
  document.documentElement.lang = lng;
});

export default i18n;
